import styled from 'styled-components'

const Divider = styled.div<{ vertical?: boolean }>`
  width: ${(props) => (props.vertical ? '' : '100%')};
  height: ${(props) => (props.vertical ? '100%' : '')};
  border: 1px solid rgba(159, 183, 195, 0.15);
`

export default Divider
